import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import AllMissingApps from './iOSmissingApp';

const MissingApps = () => {
    const [breadcrumbItems] = useState([
        { title: "Minimis", link: "/" },
        { title: "iOS Missing Apps", link: "#" },
    ]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="" breadcrumbItems={breadcrumbItems} />
                    <Row>
                        <AllMissingApps />
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default MissingApps;
